import { getCookie, setCookie, updateCookie } from '../core/utils.js';

function containsWord(inputString, searchString) {
  const regex = new RegExp(searchString);
  return regex.test(inputString);
}

function updateUtmCampaign(inputString, searchString, newCampaign) {
  const regex = /("utm_campaign":"[^|]+)\|[^"]+"/;
  const match = inputString.match(regex);
  if (match) {
    const currentCampaign = match[0].replace('"utm_campaign":"', '');
    if (!currentCampaign.endsWith(searchString)) {
      return inputString.replace(regex, `$1${newCampaign}"`);
    }
  }
  return inputString;
}

export function stickyBannerClick() {
  if (window.__mlatStickyBannerBound) return;

  const selector = (window.mlatConfig && window.mlatConfig.stickyBannerSelector) || '.sticky-banner';
  const banners = document.querySelectorAll(selector);
  if (!banners.length) return;

  window.__mlatStickyBannerBound = true;

  const today = new Date();
  const year = today.getFullYear().toString().slice(-2);
  let month = (today.getMonth() + 1).toString();
  if (month.length === 1) month = '0' + month;
  const formattedDate = year + month;

  banners.forEach((target) => {
    target.addEventListener('click', () => {
      if (!getCookie('banner_click')) {
        setCookie('banner_click', formattedDate, 31);
        if (getCookie('campaign_info')) {
          const campaigninfo = decodeURIComponent(getCookie('campaign_info'));
          const updated = updateUtmCampaign(campaigninfo, formattedDate, getCookie('devicetype') + formattedDate);
          updateCookie('campaign_info', updated);
          const device = getCookie('devicetype');
          if (!containsWord(formattedDate, device)) {
            updateCookie('devicetype', device + formattedDate);
          }
        }
      } else {
        if (getCookie('campaign_info')) {
          const campaigninfo = decodeURIComponent(getCookie('campaign_info'));
          const device = getCookie('devicetype');
          if (!containsWord(device, getCookie('banner_click'))) {
            updateCookie('devicetype', device + getCookie('banner_click'));
            const updated = updateUtmCampaign(campaigninfo, getCookie('banner_click'), getCookie('devicetype'));
            updateCookie('campaign_info', updated);
          }
        }
      }

      const pageId = target.getAttribute('data-page-id');
      if (!getCookie('banner_journey')) {
        setCookie('banner_journey', target.id, 31);
        setCookie('banner_last_click', pageId, 31);
      } else {
        if (getCookie('banner_last_click') !== pageId) {
          updateCookie('banner_journey', getCookie('banner_journey') + '|' + target.id);
        }
        updateCookie('banner_last_click', pageId);
      }
    });
  });
}
